/* eslint-disable react/jsx-props-no-spreading */
import React, { FunctionComponent, MutableRefObject, PropsWithChildren, createContext, useRef } from "react";
import { Step } from "react-joyride";
import { Tour, TourForwardRef } from "@iventis/components";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Content } from "@iventis/translations";

export const classNameTourSearch = "tour-search";
export const classNameTourBackground = "tour-background";
const classNameNewLayer = "tour-new-layer";

interface MapTourProps {
    running: boolean;
    onFinish: () => void;
}

export enum MapTourStep {
    LOCATION,
    BACKGROUND,
    CREATE_LAYER,
}

export interface MapTourContextProps {
    ref: MutableRefObject<TourForwardRef>;
}

export const MapTourContext = createContext<MapTourContextProps>(null);

export const MapTour: FunctionComponent<PropsWithChildren<MapTourProps>> = ({ running, onFinish, children }) => {
    const translate = useIventisTranslate();

    const ref = useRef<TourForwardRef>();

    const steps: Step[] = [
        {
            title: translate(Content.map3.map_tour.tip_3_location.title),
            content: translate(Content.map3.map_tour.tip_3_location.content),
            placement: "top",
            target: `.${classNameTourSearch}`,
            disableBeacon: true,
        },
        {
            title: translate(Content.map3.map_tour.tip_4_background.title),
            content: translate(Content.map3.map_tour.tip_4_background.content),
            placement: "right-end",
            target: `.${classNameTourBackground}`,
            disableBeacon: true,
        },
        {
            title: translate(Content.map3.map_tour.tip_5_layer.title),
            content: translate(Content.map3.map_tour.tip_5_layer.content),
            placement: "bottom",
            target: `.${classNameNewLayer}`,
            disableBeacon: true,
        },
    ];

    return (
        <>
            <Tour running={running} steps={steps} onFinish={onFinish} ref={ref} />
            <MapTourContext.Provider
                value={{
                    ref,
                }}
            >
                {children}
            </MapTourContext.Provider>
        </>
    );
};
